(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dino-game"]) return;
  try {
    
const canvas = document.getElementById('game');
const ctx = canvas.getContext('2d');

const titleScreen = document.getElementById('titleScreen');
const gameOverScreen = document.getElementById('gameOverScreen');
const finalScoreEl = document.getElementById('finalScore');

const GROUND_Y = 260;

let running = false;
let canJump = true;

let dino = {
  x: 50,
  y: GROUND_Y - 20,
  vy: 0,
  jumping: false,
  jumpsUsed: 0
};

let obstacles = [];
let flyingObstacles = [];
let hotObstacles = [];
let doubleJumpPowerUps = [];
let stealthPowerUps = [];
let heartPowerUps = [];

let score = 0;
let baseSpeed = 5;
let speed = baseSpeed;

let animationFrameId = null;

let doubleJumpCount = 1;

let groundSpawnRate = 0.008;
let flyingSpawnRate = 0.001;
let stealthSpawnRate = 0.0015;   // Less common stealth
let heartSpawnRate = 0.0003;
let doubleJumpSpawnRate = 0.005;

let hasStealth = false;
let stealthTimer = 0;

let health = 1;
let maxHealth = 3;

let invincible = false;
let invincibilityTimer = 0;

// Load high score from localStorage or default 0
let highScore = Number(localStorage.getItem('waltorHighScore')) || 0;

function updateInvincibility() {
  if (invincible) {
    invincibilityTimer--;
    if (invincibilityTimer <= 0) {
      invincible = false;
    }
  }
}

function takeDamage(amount = 1) {
  if (invincible || hasStealth) return;
  health -= amount;
  if (health <= 0) {
    running = false;
    finalScoreEl.textContent = score;
    gameOverScreen.classList.remove('hidden');

    if (score > highScore) {
      highScore = score;
      localStorage.setItem('waltorHighScore', highScore);
    }
  } else {
    invincible = true;
    invincibilityTimer = 60;
  }
}

function checkCollisions() {
  hotObstacles.forEach(hot => {
    if (
      dino.x < hot.x + 10 &&
      dino.x + 20 > hot.x &&
      dino.y + 20 > hot.y
    ) {
      takeDamage(2);
    }
  });

  obstacles.forEach(ob => {
    if (
      dino.x < ob.x + 10 &&
      dino.x + 20 > ob.x &&
      dino.y + 20 > ob.y
    ) {
      takeDamage();
    }
  });
  flyingObstacles.forEach(fo => {
    if (
      dino.x < fo.x + fo.width &&
      dino.x + 20 > fo.x &&
      dino.y < fo.y + fo.height &&
      dino.y + 20 > fo.y
    ) {
      takeDamage();
    }
  });
}

function startGame() {
  if (animationFrameId) cancelAnimationFrame(animationFrameId);

  running = true;
  canJump = true;
  dino.y = GROUND_Y - 20;
  dino.vy = 0;
  dino.jumping = false;
  dino.jumpsUsed = 0;

  score = 0;
  speed = baseSpeed;
  health = 2;
  doubleJumpCount = 1;
  hasStealth = false;
  stealthTimer = 0;
  invincible = false;
  invincibilityTimer = 0;

  obstacles = [];
  flyingObstacles = [];
  hotObstacles = [];
  doubleJumpPowerUps = [];
  stealthPowerUps = [];
  heartPowerUps = [];

  titleScreen.classList.add('hidden');
  gameOverScreen.classList.add('hidden');

  loop();
}

window.restartGame = function () {
  startGame();
};

document.getElementById('start').onclick = startGame;

window.addEventListener('keydown', e => {
  if (e.code === 'Space') {
    e.preventDefault();
    if (!running) {
      restartGame();
    } else {
      if (canJump) {
        dino.vy = -12;
        dino.jumping = true;
        canJump = false;
      } else if (doubleJumpCount > 0 && dino.jumpsUsed < doubleJumpCount) {
        dino.vy = -12;
        dino.jumpsUsed++;
        doubleJumpCount--;
      }
    }
  }
});

function drawStealthEffect() {
  if (!hasStealth) return;
  ctx.save();
  ctx.beginPath();
  ctx.rect(dino.x, dino.y, 20, 20);
  ctx.clip();
  ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
  for (let i = 0; i < 20; i += 4) {
    ctx.fillRect(dino.x, dino.y + i, 20, 2);
  }
  ctx.restore();
}

function drawBar(x, y, width, height, fraction, fillColor, backColor) {
  ctx.fillStyle = backColor;
  ctx.fillRect(x, y, width, height);
  ctx.fillStyle = fillColor;
  ctx.fillRect(x, y, width * fraction, height);
  ctx.strokeStyle = '#333';
  ctx.lineWidth = 1;
  ctx.strokeRect(x, y, width, height);
}

function drawStealthBar() {
  if (!hasStealth) return;

  const barWidth = 40;
  const barHeight = 6;
  const x = dino.x + 10 - (barWidth / 2);
  const y = dino.y - 12;

  const fraction = stealthTimer / 300;

  drawBar(x, y, barWidth, barHeight, fraction, '#800080', '#ccc');
}

function drawHearts() {
  for (let i = 0; i < health; i++) {
    const x = 20 + i * 30;
    const y = 20;
    ctx.fillStyle = 'red';
    ctx.beginPath();
    ctx.moveTo(x + 10, y + 10);
    ctx.bezierCurveTo(x, y, x, y + 20, x + 10, y + 20);
    ctx.bezierCurveTo(x + 20, y + 20, x + 20, y, x + 10, y + 10);
    ctx.fill();
  }

  for (let i = 0; i < doubleJumpCount; i++) {
    const x = 20 + health * 30 + i * 20;
    const y = 20;
    ctx.strokeStyle = '#00aaff';
    ctx.fillStyle = '#00aaff';
    ctx.lineWidth = 2;

    ctx.beginPath();
    ctx.moveTo(x + 10, y + 22);
    ctx.lineTo(x + 10, y + 10);

    ctx.lineTo(x + 5, y + 15);
    ctx.moveTo(x + 10, y + 10);

    ctx.lineTo(x + 15, y + 15);
    ctx.stroke();
  }
}

function loop() {
  if (!running) return;
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = '#e8f7ff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  dino.y += dino.vy;
  dino.vy += 0.6;

  if (dino.y + 20 >= GROUND_Y) {
    dino.y = GROUND_Y - 20;
    dino.vy = 0;
    dino.jumping = false;
    dino.jumpsUsed = 0;
    canJump = true;
  }

  updateInvincibility();
  checkCollisions();

  if (Math.random() < groundSpawnRate) {
    obstacles.push({ x: 800, y: GROUND_Y - 30, height: 30 });
  }
  if (Math.random() < flyingSpawnRate) {
    flyingObstacles.push({ x: 800, y: GROUND_Y - 80, width: 20, height: 20 });
  }
  if (Math.random() < 0.003) {
    hotObstacles.push({ x: 800, y: GROUND_Y - 30, height: 30 });
  }

  if (Math.random() < doubleJumpSpawnRate) {
    const powerUpY = GROUND_Y - 60;
    const powerUpX = 800;
    const overlapping = flyingObstacles.some(fo =>
      Math.abs(fo.x - powerUpX) < 40 && Math.abs(fo.y - powerUpY) < 40
    );
    if (!overlapping) {
      doubleJumpPowerUps.push({ x: powerUpX, y: powerUpY, width: 20, height: 20 });
    }
  }

  if (Math.random() < stealthSpawnRate) {
    const powerUpY = GROUND_Y - 60;
    const powerUpX = 800;
    const overlapping = flyingObstacles.some(fo =>
      Math.abs(fo.x - powerUpX) < 40 && Math.abs(fo.y - powerUpY) < 40
    );
    if (!overlapping) {
      stealthPowerUps.push({ x: powerUpX, y: powerUpY, width: 20, height: 20 });
    }
  }

  if (Math.random() < heartSpawnRate) {
    const powerUpY = GROUND_Y - 60;
    const powerUpX = 800;
    const overlapping = flyingObstacles.some(fo =>
      Math.abs(fo.x - powerUpX) < 40 && Math.abs(fo.y - powerUpY) < 40
    );
    if (!overlapping) {
      heartPowerUps.push({ x: powerUpX, y: powerUpY, width: 20, height: 20 });
    }
  }

  ctx.fillStyle = 'black';
  obstacles.forEach(ob => {
    ob.x -= speed;
    ctx.fillRect(ob.x, ob.y, 10, ob.height);
  });

  flyingObstacles.forEach(fo => {
    fo.x -= speed;
    ctx.fillRect(fo.x, fo.y, fo.width, fo.height);
  });

  ctx.fillStyle = 'red';
  hotObstacles.forEach(hot => {
    hot.x -= speed;
    ctx.fillRect(hot.x, hot.y, 10, hot.height);
  });

  ctx.fillStyle = '#00aaff';
  doubleJumpPowerUps = doubleJumpPowerUps.filter(pu => {
    pu.x -= speed;
    ctx.fillRect(pu.x, pu.y, pu.width, pu.height);
    if (
      dino.x < pu.x + pu.width &&
      dino.x + 20 > pu.x &&
      dino.y < pu.y + pu.height &&
      dino.y + 20 > pu.y
    ) {
      doubleJumpCount = Math.min(doubleJumpCount + 1, 3);
      return false;
    }
    return pu.x > -pu.width;
  });

  ctx.fillStyle = 'purple';
  stealthPowerUps = stealthPowerUps.filter(sp => {
    sp.x -= speed;
    ctx.fillRect(sp.x, sp.y, sp.width, sp.height);
    if (
      dino.x < sp.x + sp.width &&
      dino.x + 20 > sp.x &&
      dino.y < sp.y + sp.height &&
      dino.y + 20 > sp.y
    ) {
      hasStealth = true;
      stealthTimer = 300;
      return false;
    }
    return sp.x > -sp.width;
  });

  ctx.fillStyle = 'red';
  heartPowerUps = heartPowerUps.filter(hp => {
    hp.x -= speed;
    ctx.beginPath();
    ctx.arc(hp.x + hp.width / 2, hp.y + hp.height / 2, hp.width / 2, 0, Math.PI * 2);
    ctx.fill();
    if (
      dino.x < hp.x + hp.width &&
      dino.x + 20 > hp.x &&
      dino.y < hp.y + hp.height &&
      dino.y + 20 > hp.y
    ) {
      if (health < maxHealth) health++;
      return false;
    }
    return hp.x > -hp.width;
  });

  if (hasStealth) {
    stealthTimer--;
    if (stealthTimer <= 0) hasStealth = false;
  }

  obstacles = obstacles.filter(ob => ob.x > -10);
  flyingObstacles = flyingObstacles.filter(fo => fo.x > -fo.width);
  hotObstacles = hotObstacles.filter(hot => hot.x > -10);

  score++;

  if (score % 500 === 0 && speed < 15) speed += 0.5;
  if (score % 300 === 0) {
    if (groundSpawnRate < 0.04) groundSpawnRate += 0.002;
    if (flyingSpawnRate < 0.01) flyingSpawnRate += 0.001;
  }

  // Draw the dino with proper color & flashing invincibility effect
  if (invincible) {
    ctx.fillStyle = (Math.floor(invincibilityTimer / 5) % 2 === 0) ? 'gray' : 'black';
  } else {
    ctx.fillStyle = 'black';
  }
  ctx.fillRect(dino.x, dino.y, 20, 20);

  drawStealthEffect();
  drawStealthBar();
  drawHearts();

  ctx.fillStyle = '#444';
  ctx.fillRect(0, GROUND_Y, canvas.width, 4);

  // Draw score and high score aligned
  ctx.fillStyle = 'black';
  ctx.font = '20px Arial';

  const labelX = 650;          // label left align x
  const numbersRightX = 780;   // numbers right align x

  ctx.textAlign = 'left';
  ctx.fillText('Score:', labelX, 30);
  ctx.textAlign = 'right';
  ctx.fillText(score.toString(), numbersRightX, 30);

  ctx.textAlign = 'left';
  ctx.fillText('High Score:', labelX, 55);
  ctx.textAlign = 'right';
  ctx.fillText(highScore.toString(), numbersRightX, 55);

  animationFrameId = requestAnimationFrame(loop);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
